import { CommonModule, DatePipe } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatListModule } from "@angular/material/list";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { WarningComponent } from "./warning/warning.component";
import { BallsComponent } from "./ui-elements/loading-indicator/balls/balls.component";
import { HighlightComponent } from "./ui-elements/text/highlight/highlight.component";
import { UnderlineComponent } from "./ui-elements/text/underline/underline.component";
import { SavingComponent } from "./saving/saving.component";
import { LoadingComponent } from "./loading/loading.component";
import { ResizeColumnDirective } from "./directive/resize-column.directive";
import { ResizeRowDirective } from "./directive/resize-row.directive";
import { EmployeeService } from "../layout/dashboard/components/services/employee.service";
import { SubsidiarySelectorComponent } from "./subsidiary-selector/subsidiary-selector.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./services/auth-interceptor.service";
import { TranslateModule } from "@ngx-translate/core";
import { ClickOutsideDirective } from "./directive/click-outside.directive";
@NgModule({
    exports: [
        CommonModule,
        SidebarComponent,
        WarningComponent,
        NgbModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTabsModule,
        NgxDatatableModule,
        BallsComponent,
        HighlightComponent,
        UnderlineComponent,
        SavingComponent,
        LoadingComponent,
        SubsidiarySelectorComponent,
        TranslateModule
    ],
    imports: [
        MatListModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        NgbModule,
        NgxDatatableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        TranslateModule,
    ],
    declarations: [
        SidebarComponent,
        WarningComponent,
        BallsComponent,
        HighlightComponent,
        UnderlineComponent,
        SavingComponent,
        LoadingComponent,
        ResizeColumnDirective,
        ResizeRowDirective,
        SubsidiarySelectorComponent,
    ],
    providers: [
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
